<template>
  <div class="modal fade" tabindex="-1" id="changePhotoModal" aria-labelledby="changePhotoModalLabel" aria-hidden="true"
       data-bs-backdrop="static" data-bs-keyboard="false">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5 text-center">Alterar foto de perfil</h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                  @click="hideModalChangePhoto"></button>
        </div>
        <div class="modal-body">
            <h1 class="text-center">
              <i class="bi bi-person-fill-add"></i>
            </h1>
          <input ref="fileInput" type="file" accept="image/png, image/jpeg" style="display: none"
                 @change="handleFileChange">
          <div v-if="showCropper" style="margin-top: 15px;">
            <cropper
                class="cropper"
                v-if="showCropper"
                :src="cropperSrc"
                @change="change"
                ref="cropper"
                :auto-zoom="true"
                :stencil-size="{ width: 300, height: 300}"
                image-restriction="stencil"
            />
          </div>
          <div class="modal-footer">
            <button class="btn btn-primary" @click="openImagePicker">
              Escolher {{ showCropper? "outra" : "foto" }}
            </button>
            <button v-if="showCropper" class="btn btn-success" @click="crop">
              Salvar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { Cropper } from 'vue-advanced-cropper';
import 'vue-advanced-cropper/dist/style.css';

export default {
  props: {
    visibleModalChangePhoto: Boolean,
  },
  components: {
    Cropper,
  },
  data() {
    return {
      showCropper: false,
      cropperSrc: '',
      coordinates: {
        width: 0,
        height: 0,
        left: 0,
        top: 0,
      },
      image: null,
      initialPage: true
    };
  },

  methods: {
    ...mapActions(["SendImage"]),
    async crop() {
      const { canvas } = this.$refs.cropper.getResult();
      if (canvas) {
        try {
          await this.SendImage(canvas)
          this.image = null
          this.showCropper = false;
          this.cropperSrc = '';
          this.cropper = null;
          this.$emit('finishedActionHandler');
        }
        catch {
          this.$toast.error('Ocorreu um erro, tente novamente.', {
            timeout: 3000,
            closeOnClick: true
          });
        }
      }
    },
    openImagePicker() {
      this.initialPage = false;
      this.$refs.fileInput.click();
    },
    handleFileChange(event) {
      this.cropperSrc = '';
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.cropperSrc = e.target.result;
          this.showCropper = true;
        };
        reader.readAsDataURL(file);
      }
    },
    hideModalChangePhoto() {
      this.$emit("hideModalChangePhoto")
      this.image = null
      this.showCropper = false;
      this.cropperSrc = '';
      this.cropper = null;
      this.initialPage = true;
    },

  },
};
</script>

<style>
.cropper {
  height: 350px;
  width: 450px;
  background: #DDD;
}

</style>
